import React from "react";
import ServicePlanStore from "../ServicePlanStore";
import { observer, inject } from "mobx-react";

export interface ServicePlanPriceTableProps {
  selectedModel: string;
  isServicePlan: Boolean;
  handleModelVariantChange: Function;
}
interface InjectedProps extends ServicePlanPriceTableProps {
  servicePlanStore: ServicePlanStore;
}

const ServicePlanPriceTable: React.SFC<ServicePlanPriceTableProps> = (
  props
) => {
  let injectedProps = props as InjectedProps;
  const cmsVehicleModels = props.isServicePlan
    ? injectedProps.servicePlanStore.servicePlanCMSModel.response
    : injectedProps.servicePlanStore.cappedPricingCMSModel.response;

  const vehicleApiModels = props.isServicePlan
    ? injectedProps.servicePlanStore.servicePlan.response
    : injectedProps.servicePlanStore.cappedPricing.response;

  const vehicleVariantCappedServiceTotal = props.isServicePlan
    ? injectedProps.servicePlanStore.variantCappedServiceTotalModel.response
    : null;

  const vehicleSubNav = "Outback";
  let modelServicePlanContent = "";
  let modelCappedPriceServiceContent = "";
  let intervalData = null;

  const selectedModelVariant =
    injectedProps.servicePlanStore.modelVariantsSelected;

  const ctaLabels = cmsVehicleModels
    .find(
      (model) =>
        model.modelID.toLocaleLowerCase() ===
        props.selectedModel.toLocaleLowerCase()
    )
    .variants.filter(
      (filterVariant) =>
        !!filterVariant.variantGUID && !!filterVariant.servicePriceVariantName
    )
    .map((label) => label.servicePriceVariantName);

  const cmsModel = cmsVehicleModels.find(
    (model) =>
      model.modelID.toLocaleLowerCase() ===
      props.selectedModel.toLocaleLowerCase()
  );

  if (
    cmsModel.name
      .toLocaleLowerCase()
      .includes(vehicleSubNav.toLocaleLowerCase())
  ) {
    if (!!selectedModelVariant && selectedModelVariant.includes("Wilderness")) {
      intervalData = vehicleApiModels
        .find(
          (apiRespModel) =>
            apiRespModel.id.toLocaleLowerCase() ===
            props.selectedModel.toLocaleLowerCase()
        )
        .intervalData.filter(
          (i) =>
            i.name.includes("Health Check and Chat") ||
            i.modelVariantServicePrices.find(
              (m) => !m.isNotApplicable && m.variantName.includes("Wilderness")
            )
        );
    } else if (!!selectedModelVariant && selectedModelVariant.includes("XT")) {
      intervalData = vehicleApiModels
        .find(
          (apiRespModel) =>
            apiRespModel.id.toLocaleLowerCase() ===
            props.selectedModel.toLocaleLowerCase()
        )
        .intervalData.filter(
          (i) =>
            i.name.includes("Health Check and Chat") ||
            i.modelVariantServicePrices.find(
              (m) => !m.isNotApplicable && m.variantName.includes("XT")
            )
        );
    } else {
      intervalData = vehicleApiModels
        .find(
          (apiRespModel) =>
            apiRespModel.id.toLocaleLowerCase() ===
            props.selectedModel.toLocaleLowerCase()
        )
        .intervalData.filter(
          (i) =>
            i.name.includes("Health Check and Chat") ||
            i.modelVariantServicePrices.find(
              (m) =>
                !m.isNotApplicable &&
                !(
                  m.variantName.includes("XT") ||
                  m.variantName.includes("Wilderness")
                )
            )
        );
    }
    const selectedVariant = cmsModel.variants.find(
      (v) => v.servicePriceVariantName === selectedModelVariant
    );
    if (!!selectedVariant) {
      modelServicePlanContent = selectedVariant.modelServicePlanContent;
      modelCappedPriceServiceContent =
        selectedVariant.modelCappedPriceServiceContent;
    }
  } else {
    intervalData = vehicleApiModels.find(
      (apiRespModel) =>
        apiRespModel.id.toLocaleLowerCase() ===
        props.selectedModel.toLocaleLowerCase()
    ).intervalData;
    modelServicePlanContent = cmsModel.modelServicePlanContent;
    modelCappedPriceServiceContent = cmsModel.modelCappedPriceServiceContent;
  }

  return (
    <div id="servicePlanPriceInterval">
      {cmsModel.name
        .toLocaleLowerCase()
        .includes(vehicleSubNav.toLocaleLowerCase()) && (
        <div className="cappedPricingTableHeading">
          <div className="cta_wrapper">
            <h5>Please select your {cmsModel.name} variant</h5>
            {ctaLabels.map((label, i) => {
              return (
                <a
                  key={i}
                  className={selectedModelVariant !== label ? "cta-button" : ""}
                  onClick={(e) => props.handleModelVariantChange(e)}
                >
                  {label}
                </a>
              );
            })}
          </div>
        </div>
      )}
      {(!cmsModel.name
        .toLocaleLowerCase()
        .includes(vehicleSubNav.toLocaleLowerCase()) ||
        (cmsModel.name
          .toLocaleLowerCase()
          .includes(vehicleSubNav.toLocaleLowerCase()) &&
          !!selectedModelVariant)) &&
        cmsVehicleModels
          .filter(
            (model) =>
              model.modelID.toLocaleLowerCase() ===
              props.selectedModel.toLocaleLowerCase()
          )
          .map((item, i) => {
            return (
              <div key={i} className="">
                <table className="priceTable__table">
                  <thead>
                    <tr className="priceTable__tr">
                      <th
                        className="priceTable__th alignCenter"
                        style={{ minWidth: "270px" }}
                      >
                        Scheduled Service Intervals
                        <sup>{props.isServicePlan ? 2 : 1}</sup>
                      </th>
                      {item.variants
                        .filter(
                          (filterVariant) =>
                            filterVariant.variantGUID !== null &&
                            (!selectedModelVariant ||
                              filterVariant.servicePriceVariantName ===
                                selectedModelVariant)
                        )
                        .map((cmsModelItem, i) => {
                          if (cmsModelItem.servicePriceVariantName) {
                            return (
                              <th
                                key={i}
                                className="priceTable__th alignCenter"
                              >
                                {cmsModelItem.servicePriceVariantName}
                                <sup>{props.isServicePlan ? 3 : 2}</sup>
                              </th>
                            );
                          }
                        })}
                    </tr>
                  </thead>
                  <tbody>
                    {intervalData.map((intervalItem, i) => {
                      return [
                        <tr key={i} className="priceTable__tr">
                          <td className="priceTable__td alignCenter">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: intervalItem.name.replace("|", "</br>"),
                              }}
                            />
                          </td>

                          {item.variants
                            .filter(
                              (filterVariant) =>
                                filterVariant.variantGUID !== null &&
                                (!selectedModelVariant ||
                                  filterVariant.servicePriceVariantName ===
                                    selectedModelVariant)
                            )
                            .map((cmsModelItem, i) => {
                              return intervalItem.modelVariantServicePrices
                                .filter(
                                  (cappedVariant) =>
                                    (
                                      cappedVariant.variantGUID as string
                                    ).toUpperCase() ===
                                    cmsModelItem.variantGUID.toUpperCase()
                                )
                                .map((cappedServiceItem, i) => {
                                  let priceString: string;
                                  if (cappedServiceItem.isNotApplicable) {
                                    priceString = "N/A";
                                  } else if (cappedServiceItem.price === 0) {
                                    priceString = "Free";
                                  } else {
                                    priceString = `$${cappedServiceItem.price.toFixed(
                                      2
                                    )}`;
                                  }
                                  return (
                                    <td
                                      key={i}
                                      className="priceTable__td  alignCenter"
                                    >
                                      {priceString}
                                    </td>
                                  );
                                });
                            })}
                        </tr>,
                        props.isServicePlan &&
                          (intervalItem.name.includes("36 months") ||
                            intervalData.length === i + 1) && (
                            <tr key={"total" + i} className="priceTable__tr">
                              {intervalItem.name.includes("36 months")
                                ? vehicleVariantCappedServiceTotal
                                    .filter(
                                      (modelFilter) =>
                                        modelFilter.modelName === item.name &&
                                        (!selectedModelVariant ||
                                          (
                                            modelFilter.variantGUID as string
                                          ).toUpperCase() ===
                                            item.variants
                                              .find(
                                                (v) =>
                                                  v.servicePriceVariantName ===
                                                  selectedModelVariant
                                              )
                                              .variantGUID.toUpperCase())
                                    )
                                    .map((variantTotal, i) => {
                                      return i === 0
                                        ? [
                                            <td
                                              key={"totalHeader" + i}
                                              className="priceTable__td priceTable__td--price alignCenter"
                                            >
                                              {" "}
                                              Total 3 Year Service Plan Price
                                              (including GST)
                                            </td>,
                                            <td
                                              key={"total" + i}
                                              className="priceTable__td priceTable__td--price alignCenter"
                                            >
                                              {" "}
                                              <b>
                                                {" "}
                                                $
                                                {variantTotal.threeYearsPrice.toFixed(
                                                  2
                                                )}
                                              </b>{" "}
                                            </td>,
                                          ]
                                        : [
                                            <td
                                              key={"total" + i}
                                              className="priceTable__td priceTable__td--price alignCenter"
                                            >
                                              $
                                              {variantTotal.threeYearsPrice.toFixed(
                                                2
                                              )}{" "}
                                            </td>,
                                          ];
                                    })
                                : intervalData.length === i + 1 &&
                                  vehicleVariantCappedServiceTotal
                                    .filter(
                                      (modelFilter) =>
                                        modelFilter.modelName === item.name &&
                                        (!selectedModelVariant ||
                                          modelFilter.variantGUID.toUpperCase() ===
                                            item.variants
                                              .find(
                                                (v) =>
                                                  v.servicePriceVariantName ===
                                                  selectedModelVariant
                                              )
                                              .variantGUID.toUpperCase())
                                    )
                                    .map((variantTotal, i) => {
                                      return i === 0 ? (
                                        [
                                          <td
                                            key={"totalHeader" + i}
                                            className="priceTable__td priceTable__td--price alignCenter"
                                          >
                                            Total 5 Year Service Plan Price
                                            (including GST)
                                          </td>,
                                          <td
                                            key={"total" + i}
                                            className="priceTable__td priceTable__td--price alignCenter"
                                          >
                                            $
                                            {variantTotal.totalPrice.toFixed(2)}{" "}
                                          </td>,
                                        ]
                                      ) : (
                                        <td
                                          key={"total" + i}
                                          className="priceTable__td priceTable__td--price alignCenter"
                                        >
                                          {" "}
                                          ${variantTotal.totalPrice.toFixed(2)}
                                        </td>
                                      );
                                    })}
                            </tr>
                          ),
                      ];
                    })}
                  </tbody>
                </table>

                <div className="pricingDisclaimer">All prices include GST</div>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      props.isServicePlan === true
                        ? modelServicePlanContent
                        : modelCappedPriceServiceContent,
                  }}
                />
              </div>
            );
          })}
    </div>
  );
};
export default inject("servicePlanStore")(observer(ServicePlanPriceTable));
